import { __zcFin, __zcFinZ, __zcMkv, __zcPs } from "__zod-compiler-runtime__";
import {safeOptional} from '@github-ui/swp-core/schemas/safe-optional'
import * as z from 'zod'
import {BasePayloadSchema} from './base-payload'

const WhitepaperContentTypes = z.lazy(() => z.enum(['whitepaper', 'ebook']))
const WhitepaperCategories = z.lazy(() =>
  z.enum([
    'ai',
    'cloud',
    'devops',
    'github-actions',
    'github-advanced-security',
    'github-enterprise',
    'innersource',
    'open-source',
    'security',
    'software-development',
  ]),
)

/**
 * Payload schema for whitepaper index pages.
 */
export const WhitepaperIndexPayloadSchema = /* @__PURE__ */ (() => {
var __zs=z.lazy(() =>
  BasePayloadSchema.unwrap().extend({
    additionalProps: z.object({
      page: z.number(),
      totalPages: z.number(),
      filters: z.object({
        contentTypes: safeOptional(z.array(WhitepaperContentTypes)),
        topics: safeOptional(z.array(WhitepaperCategories)),
      }),
    }),
  }),
);
var __rf=[__zs._zod.innerType.shape["additionalProps"].shape["filters"].shape["contentTypes"]._zod.def.innerType._zod.def.out._zod.def.transform,__zs._zod.innerType.shape["additionalProps"].shape["filters"].shape["topics"]._zod.def.innerType._zod.def.out._zod.def.transform];
var __bf_2={};
var __rfn_12=__rf[0];
var __rfn_16=__rf[1];
function __vb_21(input){var __bv_3,__bs_4,__bv_5,__bv_6,__bv_7,__bv_8,__bv_9,__bv_10,__bx_11,__bw_13,__bv_14,__bx_15,__bw_17,__bo_18,__bo_19,__bo_20;if(typeof input!=="object"||input===null||Array.isArray(input))return __bf_2;__bv_3=input["contentfulRawJsonResponse"];if(!(typeof __bv_3==="object"&&__bv_3!==null&&!Array.isArray(__bv_3)))return __bf_2;__bs_4=__zcPs(__bv_3);__bv_5=input["userLoggedIn"];if(!((__bv_5===undefined||(typeof __bv_5==="boolean"))))return __bf_2;__bv_6=input["additionalProps"];if(typeof __bv_6!=="object"||__bv_6===null||Array.isArray(__bv_6))return __bf_2;__bv_7=__bv_6["page"];if(!(Number.isFinite(__bv_7)))return __bf_2;__bv_8=__bv_6["totalPages"];if(!(Number.isFinite(__bv_8)))return __bf_2;__bv_9=__bv_6["filters"];if(typeof __bv_9!=="object"||__bv_9===null||Array.isArray(__bv_9))return __bf_2;__bv_10=__bv_9["contentTypes"];if(__bv_10===undefined){__bw_13=undefined;}else{__bx_11=__rfn_12(__bv_10);__bw_13=__bx_11;}__bv_14=__bv_9["topics"];if(__bv_14===undefined){__bw_17=undefined;}else{__bx_15=__rfn_16(__bv_14);__bw_17=__bx_15;}__bo_18={};if(__bw_13!==undefined||("contentTypes" in __bv_9)){__bo_18["contentTypes"]=__bw_13;}if(__bw_17!==undefined||("topics" in __bv_9)){__bo_18["topics"]=__bw_17;}__bo_19={"page":__bv_7,"totalPages":__bv_8,"filters":__bo_18};__bo_20={"contentfulRawJsonResponse":__bs_4};if(__bv_5!==undefined||("userLoggedIn" in input)){__bo_20["userLoggedIn"]=__bv_5;}__bo_20["additionalProps"]=__bo_19;return __bo_20;}
var __rfm_z=__zs.safeParse;
function safeParse_WhitepaperIndexPayloadSchema(input){
var __bd_22=__vb_21(input);
if(__bd_22!==__bf_2){return{success:true,data:__bd_22};}
return __zcFinZ(__rfm_z,__zs,input);
}
return __zcMkv(safeParse_WhitepaperIndexPayloadSchema,__zs,null,null);
})()

export type WhitepaperIndexPayload = z.infer<typeof WhitepaperIndexPayloadSchema>

export function toWhitepaperIndexPayload(payload: unknown): WhitepaperIndexPayload {
  return WhitepaperIndexPayloadSchema.parse(payload)
}
